import React, { useEffect, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import { MdCircleNotifications } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { AiFillHome } from "react-icons/ai";
import { IoIosArrowForward } from "react-icons/io";
import SearchBar from "../../../components/searchBar/SearchBar";
import Card from "../../../components/cards/Card";
import Table from "../../../components/tables/Table";
import Pagination from "../../../components/pagination/Pagination";
import { Link, useNavigate } from "react-router-dom";
import ConfirmModal from "../../../components/popups/confirmationModal/ConfirmModal";
import {
    deleteOtherDevicesApi,
    getOtherDevicesApi,
} from "../../../services/apis/otherdevices";
import showAlert from "../../../components/errorBoundries/Errors";
import Toast, { showSuccessToast } from "../../../components/toastify/Toast";
function OtherDevices() {
    const navigate = useNavigate();
    const headers = ["Created On", "Updated On", "Name",];
    const keys = ["created_at", "updated_at", "name"];
    const [modalIsOpen, setIsOpen] = useState(false);
    const [data, setFirmwareData] = useState({});
    const [isConfirmDelete, setIsConfirmDelete] = useState(false);
    const [notificationId, setNotificationId] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;

    useEffect(() => {
        fetchData("");
    }, []);

    const fetchData = async (query) => {
        try {
            const respones = await getOtherDevicesApi("?search=" + query);
            if (respones?.status === 200) {
                setFirmwareData(respones?.data);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                showAlert("Error", errors, "error");
            }
        } catch (error) {
            let errors =
                error?.response?.data?.detail ||
                "Opps! Something went wrong, please try again.";
            showAlert("Error", errors, "error");
        }
    };

    const openModal = (row) => {
        setNotificationId(row?.id);
        setIsConfirmDelete(false);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setIsConfirmDelete(false);
    };

    const handleEdit = (rowData) => {
        navigate(`/other-devices/edit`, { state: { rowData } });
    };

    useEffect(() => {
        if (isConfirmDelete === true) {
            const fetchData = async () => {
                try {
                    const respones = await deleteOtherDevicesApi(notificationId);
                    if (respones?.status === 204) {
                        try {
                            const respones = await getOtherDevicesApi();
                            if (respones?.status === 200) {
                                setFirmwareData(respones?.data);
                            } else {
                                let errors = "Opps! Something went wrong, please try again.";
                                showAlert("Error", errors, "error");
                            }
                        } catch (error) {
                            let errors =
                                error?.response?.data?.detail ||
                                "Opps! Something went wrong, please try again.";
                            showAlert("Error", errors, "error");
                        }
                        setIsOpen(false);
                        showSuccessToast("Notification deleted successfully!");
                    } else {
                        let errors = "Opps! Something went wrong, please try again.";
                        showAlert("Error", errors, "error");
                    }
                } catch (error) {
                    let errors =
                        error?.response?.data?.detail ||
                        "Opps! Something went wrong, please try again.";
                    showAlert("Error", errors, "error");
                }
            };
            fetchData();
        }
    }, [isConfirmDelete]);

    const extraColumnRenderer = (row) => (
        <div className="flex space-x-2">
            <FiEdit
                size={23}
                onClick={() => handleEdit(row)}
                className="cursor-pointer text-primary"
            />
            <MdDelete
                size={25}
                onClick={() => openModal(row)}
                className="cursor-pointer text-red-600"
            />
        </div>
    );
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const handleSearch = (query) => {
        fetchData(query);
    };
    return (
        <div className="">
            <Toast />
            {/* Top Section Begin */}
            <div className="flex gap-3 items-center font-medium text-gray-500">
                <AiFillHome />
                <p>Home</p>
                <IoIosArrowForward />
                <p>Other Devices</p>
            </div>
            {/* Top Section End */}
            {/* Add Notification Begin */}
            <div className="flex justify-between pt-3">
                <div className="w-[30%]">
                    <SearchBar
                        placeholder="Search in Other Devices..."
                        onSearch={handleSearch}
                    />
                </div>
                <div>
                    <Link to="/other-devices/add">
                        <button
                            type="button"
                            className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-md w-full px-3 py-2.5 text-center flex items-center gap-1"
                        >
                            <IoMdAdd style={{ color: "white" }} size={23} />
                            Add New
                        </button>
                    </Link>
                </div>
            </div>
            {/* Add Notification End */}
            {/* Card Section Begin */}
            <div className="w-[280px] py-3">
                <Card
                    title="Total Devices"
                    count={data?.count}
                    icon={<svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.5999 8.40039H8.3999V15.6004H15.5999V8.40039Z" fill="#6B7280" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.4002 2.4002C8.4002 2.08194 8.52662 1.77671 8.75167 1.55167C8.97671 1.32662 9.28193 1.2002 9.60019 1.2002C9.91845 1.2002 10.2237 1.32662 10.4487 1.55167C10.6738 1.77671 10.8002 2.08194 10.8002 2.4002V3.6002H13.2002V2.4002C13.2002 2.08194 13.3266 1.77671 13.5517 1.55167C13.7767 1.32662 14.0819 1.2002 14.4002 1.2002C14.7185 1.2002 15.0237 1.32662 15.2487 1.55167C15.4738 1.77671 15.6002 2.08194 15.6002 2.4002V3.6002H18.0002C18.6367 3.6002 19.2472 3.85305 19.6973 4.30314C20.1473 4.75323 20.4002 5.36368 20.4002 6.0002V8.4002H21.6002C21.9185 8.4002 22.2237 8.52662 22.4487 8.75167C22.6738 8.97671 22.8002 9.28193 22.8002 9.60019C22.8002 9.91845 22.6738 10.2237 22.4487 10.4487C22.2237 10.6738 21.9185 10.8002 21.6002 10.8002H20.4002V13.2002H21.6002C21.9185 13.2002 22.2237 13.3266 22.4487 13.5517C22.6738 13.7767 22.8002 14.0819 22.8002 14.4002C22.8002 14.7185 22.6738 15.0237 22.4487 15.2487C22.2237 15.4738 21.9185 15.6002 21.6002 15.6002H20.4002V18.0002C20.4002 18.6367 20.1473 19.2472 19.6973 19.6973C19.2472 20.1473 18.6367 20.4002 18.0002 20.4002H15.6002V21.6002C15.6002 21.9185 15.4738 22.2237 15.2487 22.4487C15.0237 22.6738 14.7185 22.8002 14.4002 22.8002C14.0819 22.8002 13.7767 22.6738 13.5517 22.4487C13.3266 22.2237 13.2002 21.9185 13.2002 21.6002V20.4002H10.8002V21.6002C10.8002 21.9185 10.6738 22.2237 10.4487 22.4487C10.2237 22.6738 9.91845 22.8002 9.60019 22.8002C9.28193 22.8002 8.97671 22.6738 8.75167 22.4487C8.52662 22.2237 8.4002 21.9185 8.4002 21.6002V20.4002H6.0002C5.36368 20.4002 4.75323 20.1473 4.30314 19.6973C3.85305 19.2472 3.6002 18.6367 3.6002 18.0002V15.6002H2.4002C2.08194 15.6002 1.77671 15.4738 1.55167 15.2487C1.32662 15.0237 1.2002 14.7185 1.2002 14.4002C1.2002 14.0819 1.32662 13.7767 1.55167 13.5517C1.77671 13.3266 2.08194 13.2002 2.4002 13.2002H3.6002V10.8002H2.4002C2.08194 10.8002 1.77671 10.6738 1.55167 10.4487C1.32662 10.2237 1.2002 9.91845 1.2002 9.60019C1.2002 9.28193 1.32662 8.97671 1.55167 8.75167C1.77671 8.52662 2.08194 8.40019 2.4002 8.4002H3.6002V6.0002C3.6002 5.36368 3.85305 4.75323 4.30314 4.30314C4.75323 3.85305 5.36368 3.6002 6.0002 3.6002H8.4002V2.4002ZM6.0002 6.0002H18.0002V18.0002H6.0002V6.0002Z" fill="#6B7280" />
                    </svg>}
                />
            </div>
            {/* Card Section End */}
            {/* Table Begin */}
            <div className="mt-2">
                <Table
                    headers={headers}
                    keys={keys}
                    rows={data?.results}
                    extraColumn="Actions"
                    extraColumnRenderer={extraColumnRenderer}
                />
            </div>
            {/* Table End */}
            {/* Pagination Begin */}
            <div className="xl:pl-5 pl-0">
                <Pagination
                    currentPage={currentPage}
                    totalPages={Math.ceil(data?.count / pageSize)}
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setFirmwareData}
                />
            </div>
            {/* Pagination End */}
            <ConfirmModal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Other Device Model"
                onClose={closeModal}
                setIsConfirmDelete={setIsConfirmDelete}
            />
        </div>
    );
}

export default OtherDevices;